import './contentpage.less'

import Blocks, {BlockType} from 'views/partials/blocks'
import {Image, Picture, classes} from '@codeurs/front'
import {ImageType, LinkType} from 'types/types'

import ContentContainer from 'views/layout/contentcontainer'
import FeaturedPublication from 'views/partials/features/featuredpublication'
import ImageLink from 'views/partials/imagelink'
import Layout from 'views/layout'
import {PublicationType} from 'views/partials/features/publicationlink'
import Wysiwyg from 'views/layout/wysiwyg'
import m from 'mithril'

export default class ContentPage<Data = {}> extends Layout<
	{
		blocks: Array<BlockType>
		intro_image: ImageType
		intro_image_link: LinkType
		text: string
		key?: string
	} & Data &
		({publication: PublicationType} | PublicationType)
> {
	view() {
		const {
			blocks,
			channel,
			lists,
			intro_image,
			intro_image_link: image_link,
			text,
			key
		} = this.attrs.data
		return m('.contentpage',
			{...classes({mod: channel == 'about' ? 'about' : ''})},
			[
				m(ContentContainer, {mod: this.getMods(channel)}, [
					m('.contentpage-intro', [
						intro_image &&
							m(ImageLink,
								{image_link},
								m(Picture, {
									...intro_image,
									...classes('contentpage-intro-image')
								})
							),
						text &&
							m(Wysiwyg, {
								mod: 'intro',
								...classes('contentpage-intro-description'),
								html: text
							})
					]),
					m(Blocks, {blocks, lists, channel}),
					this.viewAttachedPublication(),
					this.viewContent(),
					key &&
						key == 'cookie_declaration' &&
						m('script', {
							id: 'CookieDecleration',
							src:
								'https://consent.cookiebot.com/99ea9f7f-de64-4f8c-9320-1f7e194ae322/cd.js',
							type: 'text/javascript',
							async: 'async'
						})
				])
			]
		)
	}
	getMods(channel: string): string {
		if (channel) return channel
	}
	viewAttachedPublication() {
		const {data} = this.attrs
		const {lists, channel} = data
		const publication: PublicationType =
			'publication' in data ? data.publication : data
		if (!('publication' in data) && channel == 'article') return null
		if (channel == 'publication' || channel == 'article')
			return m('.contentpage-featured',
				{
					oncreate: (vnode: any) => {
						const el = vnode.dom
						if (!el.firstChild) return
						const height = el.firstChild.clientHeight
						let offset = el.offsetTop
						setTimeout(() => {
							if (height - el.offsetTop > 0)
								el.style.paddingBottom = height - el.offsetTop + 'px'
						}, 500)
					}
				},
				m(FeaturedPublication, {
					featured: publication,
					lists,
					mod:
						channel == 'article'
							? 'article'
							: channel == 'publication'
							? 'publication'
							: null,
					channel
				})
			)
	}
	viewContent() {
		return null
	}
}
